import QAPolicyForm, { type QAPolicyData } from '../../qa/QAPolicyForm';

// QAPolicyData is re-exported so existing wizard imports
// (WizardShell, Step5ReviewConfirm) keep resolving from this module.
export type { QAPolicyData };

interface Props {
  tenantId:       string;
  onStepComplete: (data: QAPolicyData) => void;
  savedData?:     QAPolicyData;
}

// Thin wizard wrapper around the shared QAPolicyForm (QA.A3 #950). The form
// itself is surface-agnostic; the wizard supplies the step-advance callback
// and the "Save & Continue" affordance.
export default function Step3QAPolicy({ tenantId, onStepComplete, savedData }: Props) {
  return (
    <QAPolicyForm
      tenantId={tenantId}
      savedData={savedData}
      submitLabel="Save & Continue →"
      onSaved={onStepComplete}
    />
  );
}
